import { Authority, useAuthenticated } from "providers/A12n"
import { CellProps, Column } from "react-table"
import { Client, ClientStatus } from "models/common"

import { ColorMap } from "utils/color"
import { ReactComponent as DeleteIcon } from "assets/delete.svg"
import MoreActions from "components/MoreActions"
import { Status } from "components/Status"
import { css } from "@emotion/css"
import { useI18n } from "providers/I18n"

const styles = {
  cnt: css`
    text-align: center;
  `,
  name: css`
    display: flex;
    min-width: 8rem;
    min-height: 41px;
    align-items: center;
  `,
}

type GetColumns = (
  onDelete: (id: string) => void,
  hasAuthority: (allowed: Authority[]) => boolean,
) => Array<Column<Client>>

export const getColumns: GetColumns = (onDelete, hasAuthority) => {
  const market_columns = [
    {
      fixed: true,
      default: true,
      sortable: false,
      header: "clients.list.actions",
      id: "actions",
      Header: () => {
        const { t } = useI18n()
        return <div>{t("clients.list.actions")}</div>
      },
      Cell: function (props: CellProps<Client>) {
        const { id } = props.row.original
        const { t } = useI18n()
        const { hasAuthority } = useAuthenticated()
        return (
          <MoreActions
            options={[
              // DELETE
              {
                hidden: !hasAuthority(["AUTH_DELETE_AGENCY_CLIENT"]),
                label: t("market-agencies.list.delete.action"),
                icon: <DeleteIcon />,
                onClick: () => {
                  onDelete(id)
                },
              },
            ]}
          />
        )
      },
    },
  ]

  let custom_columns = [] as any
  if (!hasAuthority(["AUTH_ACCESS_MARKET_ADMIN"])) {
    custom_columns = market_columns
  }

  return [
    {
      fixed: true,
      default: true,
      sortable: false,
      header: "clients.list.name",
      id: "name",
      Cell: function (props: CellProps<Client>) {
        const { name } = props.row.original

        return <div className={styles.name}>{name}</div>
      },
    },
    {
      default: true,
      sortable: true,
      header: "clients.list.status",
      id: "clients.list.status",
      accessor: "status",
      Cell: function (props: CellProps<Client, ClientStatus>) {
        const { value: status } = props
        const { t } = useI18n()
        return status === null ? null : (
          <Status color={ColorMap[status]}>
            {t(`status.${status ?? ""}`)}
          </Status>
        )
      },
    },
    {
      default: true,
      sortable: false,
      header: "clients.list.companies",
      id: "companies",
      Cell: function (props: CellProps<Client>) {
        const { companies } = props.row.original
        return (companies || [])?.map((c, cidx) => (
          <div key={cidx}>{`${c?.name} - ${c?.clientCode}`}</div>
        ))
      },
    },
    {
      default: true,
      sortable: false,
      header: "clients.list.groupName",
      id: "clients.list.groupName",
      accessor: "groupName",
    },
    ...custom_columns,
  ]
}

export const filters = []
export const sortByDefault = "updated_date,DESC"
